import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Td,
  Tr,
} from "@chakra-ui/react";
import { FiEdit, FiEye, FiSearch, FiTrash, FiUpload } from "react-icons/fi";
import TableView from "../../components/TableView";
import { useSelector } from "react-redux";
import CustomButton from "../../components/ButtonComp";
import CustomToolTip from "../../components/CustomTooltip";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import {
  get_all_inventory_list,
  get_inventory_list,
} from "../../redux/inventorySlice";
import { get_full_product_list } from "../../redux/productSlice";
import { baseUrl } from "../../utils/utils";

const Inventory = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const { inventory_list, total_inventory_count } = useSelector(
    (state) => state.inventory
  );

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `inventory.php`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.statusText}`);
      }

      const result = await response.json();
      console.log(result);
      if (result?.success) {
        store.dispatch(get_inventory_list({ page: page, rows: rows }));
        toast.success(result?.message);
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      console.error("Error fetching product:", error);
      toast.error("Failed to load product data", {
        position: "top-right",
        autoClose: 5000,
      });
      navigate("/products");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    store.dispatch(get_inventory_list({ page: page, rows: rows }));
    store.dispatch(get_full_product_list());
    store.dispatch(get_all_inventory_list());
  }, []);
  return (
    <>
      <Card
        bg="#fff"
        p={2}
        flexDirection={["column", "row"]}
        alignItems={["stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <InputGroup bg="#f4f5f7" borderRadius={5} w={["100%", "sm"]}>
          <Input placeholder="Search..." />
          <InputRightElement>
            <FiSearch />
          </InputRightElement>
        </InputGroup>

        <Spacer display={["none", "block"]} />

        <CustomButton
          title="Add Inventory"
          onClick={() =>
            navigate("/inventory/add-inventory", {
              state: { inventory_list: inventory_list },
            })
          }
          w={["100%", "auto"]}
        />
      </Card>

      <div>
        <TableView
          headData={[
            "S.No.",
            "Product Name",
            "Category",
            "Type",
            "OS Fulls",
            "OS Empties",
            "Current Fulls",
            "Current Empties",
            "Security Deposit",
            "Opening Date",
            "Action",
          ]}
          body={inventory_list?.map((el, i) => (
            <Tr>
              <Td textAlign="center">{i + initialValue}</Td>
              <Td textAlign="center">{el.product_name}</Td>
              <Td textAlign="center">{el.category}</Td>
              <Td textAlign="center">{el.type}</Td>
              <Td textAlign="center">{el.os_fulls}</Td>
              <Td textAlign="center">{el.os_emptys}</Td>
              <Td textAlign="center">{el.cs_fulls}</Td>
              <Td textAlign="center">{el.cs_emptys}</Td>
              <Td textAlign="center">{el.securitydeposit}</Td>
              <Td textAlign="center">{el.opening_date}</Td>
              <Td textAlign="center">
                {
                  <Flex justify={"center"} gap={4}>
                    {/* <CustomToolTip
                      button={
                        <FiEdit
                          size={20}
                          cursor={"pointer"}
                          onClick={() =>
                            navigate(`/inventory/edit/${el.id}`, { state: el })
                          }
                        />
                      }
                      mess={"Edit Product"}
                    /> */}
                    <CustomToolTip
                      button={
                        <FiTrash
                          size={20}
                          cursor={"pointer"}
                          color="#F00"
                          onClick={() => {
                            setDeleteId(el.id);
                            setDeleteDialog(true);
                          }}
                        />
                      }
                      mess={"Delete Product"}
                    />
                  </Flex>
                }
              </Td>
            </Tr>
          ))}
          initialValue={initialValue}
          page={page}
          rows={rows}
          total_value={total_inventory_count}
          pagination
          onChange={(e) => {
            setInitialValue(1);
            setpage(1);
            console.log("e.target.value", page);
            store.dispatch(
              get_inventory_list({ page: 1, rows: e.target.value })
            );
            setRows(e.target.value);
          }}
          onPrevious={() => {
            initialValue == 1 ||
              setInitialValue(Number(initialValue) - Number(rows));
            page == 1 || setpage(page - 1);
            page === 1 ||
              store.dispatch(
                get_inventory_list({ page: page - 1, rows: rows })
              );
          }}
          onNext={() => {
            rows * page >= total_inventory_count ||
              setInitialValue(Number(initialValue) + Number(rows));
            rows * page >= total_inventory_count || setpage(page + 1);
            rows * page >= total_inventory_count ||
              store.dispatch(
                get_inventory_list({ page: page + 1, rows: rows })
              );
          }}
        />
        <ConfirmDialog
          isOpen={deleteDialog}
          onClose={() => setDeleteDialog(false)}
          onConfirm={handleDelete}
          type="delete"
          title="Delete Inventory"
          message="Are you sure you want to delete this Inventory? This action cannot be undone and will remove all associated data."
          confirmText="Delete"
          cancelText="Cancel"
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default Inventory;
